/**
 * @generated SignedSource<<96b0d47a239a4453b03d10a247c9e028>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceStarActionButtonSpaceFragment$data = {
  readonly currentUser: {
    readonly isFavourited: boolean;
  };
  readonly " $fragmentType": "SpaceStarActionButtonSpaceFragment";
};
export type SpaceStarActionButtonSpaceFragment$key = {
  readonly " $data"?: SpaceStarActionButtonSpaceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceStarActionButtonSpaceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceStarActionButtonSpaceFragment",
  "selections": [
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourited"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "8952ed3b4f2eb093d58223c1da19fdac";

export default node;
